import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Base64 } from 'js-base64';

@Component({
  selector: 'wf-peppol-detail-raw-xml',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule],
  templateUrl: './peppol-detail-raw-xml.component.html',
  styleUrl: './peppol-detail-raw-xml.component.scss',
  host: { class: 'wf-peppol-detail-raw-xml' },
})
export class PeppolDetailRawXmlComponent {
  readonly content = input<string | null>(null);

  readonly showMore = output<void>();

  protected readonly placeholder = '<?xml version="1.0" encoding="utf-8" ?>';

  protected readonly decodedContent = computed<string | null>(() => {
    const raw = this.content();
    return raw ? Base64.decode(raw) : null;
  });
}
